import React from 'react'

import { withPlugin } from '@flamingo_tech/funkgo'
import styles from './ProductSizeChartSection.module.css'
import cx from '../../../utils/className'
import { withDrawer } from '../../common/Drawer/Drawer'

import ProductSizeGuide from './ProductSizeGuide'


const SizeChartContent = props => {
  return <ProductSizeGuide headerTitle={props.productTitle} {...props} />
}

const SizeChartDrawer = withDrawer(withPlugin(ProductSizeGuide))

// 弹窗
const SizeChartModal = props => {
  return <SizeChartDrawer  headerTitle={props.$i18n.transl('core.product.sizeGuide')} {...props} />
}

const ProductSizeChartSection = ({ onClick, $i18n, $detector }) => {
  const isDesktop = $detector &&  $detector.isDesktop()

  return (
    <h2 className={cx(styles.section, isDesktop && styles.isDesktop)} onClick={onClick}>
      {$i18n.transl('core.product.sizeGuide')}
    </h2>
  )
}

export default ProductSizeChartSection

export {
  SizeChartModal,
  SizeChartContent
}